import { createContext } from "react"
import { ModulosFornecedorInicial, ModulosFornecedorModel } from "../models/modulosFornecedorModel"
import { ModulosFornecedorActionModel } from "./modulosFornecedorActions"

type ModulosFornecedorContextProps = {
    dados: ModulosFornecedorModel
    dispatch: React.Dispatch<ModulosFornecedorActionModel>
    erroCarregamento: string | null
}

const initialContextValue: ModulosFornecedorContextProps = {
    dados: ModulosFornecedorInicial,
    dispatch: () => {},
    erroCarregamento: null,
}

export const ModulosFornecedorContext = createContext<ModulosFornecedorContextProps>(initialContextValue)
